const millisecondsInSecond = 1000;
const secondsInMinute = 60;
const fiveMinutes = 5;

// Token validation time interval
export const TOKEN_VALIDATION_INTERVAL = fiveMinutes * secondsInMinute * millisecondsInSecond;
